import { Divider, ListItem, ListItemButton, ListItemText } from "@clipboard-health/ui-components";

import { useSkillsAssessmentFeatureFlags } from "../../SkillsAssessment/api/useSkillsAssessmentFeatureFlags";
import { useSkillsAssessments } from "../../SkillsAssessment/api/useSkillsAssessments";
import { type Worker } from "../../Worker/api/types";

interface Props {
  worker: Worker;
  onClick: () => void;
}
export function OrientationMenuItem(props: Props) {
  const { onClick, worker } = props;
  const { userId } = worker;

  const { skillsAssessmentConfig, isClipboardOrientationEnabled } =
    useSkillsAssessmentFeatureFlags();
  const { data: skillsAssessments, isSuccess: isSuccessSkillsAssessments } = useSkillsAssessments(
    {
      workerId: userId,
      qualificationNames: skillsAssessmentConfig.availableQualificationNames,
    },
    { staleTime: 0 }
  );

  if (!isSuccessSkillsAssessments || skillsAssessments.data.length === 0) {
    return null;
  }

  if (!isClipboardOrientationEnabled) {
    return null;
  }

  return (
    <>
      <Divider />
      <ListItem>
        <ListItemButton hideCallToActionIcon onClick={onClick}>
          <ListItemText
            primary="Demo Shift"
            secondary="Watch a quick virtual walkthrough before you start booking and earning"
          />
        </ListItemButton>
      </ListItem>
    </>
  );
}
